/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { ILabTestItem } from 'app/shared/model/lab-test-item.model';
import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { Gender } from 'app/shared/model/enumerations/gender.model';

export interface ILabItemMeasure {
  id?: string;
  ageMin?: number | null;
  ageMax?: number | null;
  gender?: keyof typeof Gender | null;
  weightMin?: number | null;
  weightMax?: number | null;
  displayPrecision?: boolean | null;
  hiAbsolute?: number | null;
  hiCritical?: number | null;
  hiNormal?: number | null;
  lowAbsolute?: number | null;
  lowCritical?: number | null;
  lowNormal?: number | null;
  units?: string | null;
  cursor?: number;
  active?: boolean;
  created?: dayjs.Dayjs | null;
  microSec?: number;
  timestampentry?: number;
  lastupdated?: number;
  testItem?: ILabTestItem;
  diagLab?: IDiagLab | null;
}

export const defaultValue: Readonly<ILabItemMeasure> = {
  displayPrecision: false,
  active: false,
};
